import React from "react";
import { StyledFooter } from "./../styles/StyledFooter";

const Footer = () => {
  return <StyledFooter>Created by Alexandra for Taitotalo</StyledFooter>;
};

export default Footer;
